import { gql } from '@apollo/client';
const ADD_PROJECTION = gql `
  mutation AddProjection($modelSpecificationId: ID!, $file: String!) {
    addModelSpecificationProjection(modelSpecificationId: $modelSpecificationId, file: $file) {
      modelSpecificationProjection {
        id
        name
        number
        picture
        points {
          edges {
            node {
              id
              x
              y
              note
              noteX
              noteY
              photoNumber
              isVisible
              typeCode
              photo
              component {
                id
                name
                productCategory {
                  id
                  type
                  typeLabelPL
                  typeLabelEN
                  typeIcon
                }
              }
            }
          }
        }
      }
    }
  }
`;
export default ADD_PROJECTION;
